import React from 'react';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import { SimpleHeader, SimpleHeaderContainer } from './simple-header.style';
import { NavLogo } from '../nav-bar/style';

const Header = () => {
    return (
        <SimpleHeaderContainer>
            <SimpleHeader style={{ justifyContent: 'flex-start' }}>
                <NavLogo linkTo="/" {...qaAttribute('gumtree-logo')} data-testid="gumtree-logo" />
            </SimpleHeader>
        </SimpleHeaderContainer>
    );
};

export default Header;
